import {
  axiosInstance,
  GET_CONVERSATION_ANALYSIS,
  GET_CONTENT_CONVERSATION,
} from "../apiurls/apiurls";

export const getConversationAnalysis = async (formData) => {
  try {
    const response = await axiosInstance.post(
      GET_CONVERSATION_ANALYSIS,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error in getConversationAnalysis:", error);
    throw error;
  }
};

export const getContentConversation = async (formData, params) => {
  try {
    let url = GET_CONTENT_CONVERSATION;
    if (params) {
      const queryString = new URLSearchParams(params).toString();
      url = `${url}?${queryString}`;
    }
    const response = await axiosInstance.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (error) {
    console.error("Error in getContentConversation:", error);
    throw error;
  }
};

export const sendConversationAudio = async (audioBlob, question) => {
  try {
    const mp3Blob = new Blob([audioBlob], { type: "audio/mp3" });
    const formData = new FormData();
    formData.append("audio", mp3Blob, "audio.mp3");

    if (question) {
      const userData = { question: question };
      formData.append("user_data", JSON.stringify(userData));
    }

    return await getConversationAnalysis(formData);
  } catch (error) {
    console.error("Error sending audio to API:", error);
    throw error;
  }
};

export const textToSpeechBlob = async (text) => {
  return new Promise((resolve, reject) => {
    if (!("speechSynthesis" in window)) {
      reject(new Error("Speech synthesis not supported"));
      return;
    }

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 1.0;
    utterance.pitch = 1.0;
    utterance.volume = 1.0;

    utterance.onend = () => {
      resolve(null);
    };

    utterance.onerror = (event) => {
      reject(event);
    };

    window.speechSynthesis.speak(utterance);
  });
};
